import type { ReactElement } from 'react';

import BpkMobileScrollContainer from '@skyscanner-internal/backpack-web/bpk-component-mobile-scroll-container';
import classNames from 'classnames';

import STYLES from './MobileScrollContainer.module.scss';

type Props = {
  animated?: boolean;
  children: ReactElement;
  containerClassName?: string;
  pills?: boolean;
};

export const MobileScrollContainer = ({
  animated,
  children,
  containerClassName,
  ...rest
}: Props): ReactElement => {
  const scrollContainerClassName = classNames(containerClassName, {
    [STYLES.animated]: animated,
  });

  return (
    <BpkMobileScrollContainer
      {...rest}
      className={scrollContainerClassName || undefined}
      leadingIndicatorClassName={STYLES.leadingIndicator}
      trailingIndicatorClassName={STYLES.trailingIndicator}
    >
      {children}
    </BpkMobileScrollContainer>
  );
};
